export default __webpack_public_path__ + "static/media/Badge_Placement_Scouts.f26382cc.jpeg";